import React from "react";

import { applyQRFormDefaultValues } from "@/utils/formHelper";

import {
  omittedValues,
  onBindImage,
  onBindSocialNetworks,
  onBindThemePicker,
} from "@/utils/qrEditorHelper";

import { QRWebsiteProps } from "./types";
import { QREditorContext } from "@/contexts/QREditorContext";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";
import { qrWebsiteValidation } from "@/utils/validators/qr-website";
import { NAMESPACES } from "@/internals/constants/namespaces";
import { useTranslation } from "react-i18next";
import "./styles.scss";

export function QRWebsite({ data }: QRWebsiteProps) {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const { qrData, setQrData } = React.useContext<QREditorContextProps<"website">>(QREditorContext);

  const [qrWebsiteData, setQrWebsiteData] = React.useState<QRProps<"website">>(qrData);
  const [renderForm, setRenderForm] = React.useState(false);

  const dataWebsiteWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);

  onBindImage(dataWebsiteWithDefaultValues, "qrWebsiteInformationLogo", omittedValues(qrData.data));
  onBindThemePicker(
    dataWebsiteWithDefaultValues,
    "qrwebsiteThemePicker",
    omittedValues(qrData.data)
  );
  onBindSocialNetworks(
    dataWebsiteWithDefaultValues,
    "qrWebsiteSocials",
    "socialNetworks",
    omittedValues(qrData.data)
  );

  const onUpdateState = ({ field, value }) => {
    if (field === "file" || field == "") return;
    setQrData(
      {
        ...qrData,
        data: {
          ...qrData.data,
          [field]: value,
        },
      },
      omittedValues(qrData.data)
    );
  };

  React.useEffect(() => {
    setQrWebsiteData(qrData);
  }, [qrData]);

  React.useEffect(() => {
    setQrData({ ...qrWebsiteData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-website">
      <Typography
        Tag="p"
        size="xl"
        classname="u-bold u-spacing-5"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataWebsiteWithDefaultValues}
        schema={qrWebsiteValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => setRenderForm(isValidForm)}
      />
    </div>
  );
}
